import { angularInvoke } from './vvuejs.parcel.mjs';
import Vue from '/vodalys/vvuejs/vue'

Vue.filter('angularFilter', function (...args) {
    let filterName = args.pop()
    return angularInvoke(function ($filter) {
        return $filter(filterName)(...args)
    })

})

Vue.filter('vtranslate', function (data) {
    return angularInvoke(function (vTranslateService) {
        return vTranslateService.translate(data);
    });
});

Vue.filter('sortByWeight', function (values) {
    if (values instanceof Object) {
        return Object.values(values).sort((a, b) => (a.weight ?? 0) - (b.weight ?? 0))
    }
    else if (values instanceof Array) {
        return values.sort((a, b) => (a.weight ?? 0) - (b.weight ?? 0))
    }
    return values
})
